
/*  SPLIT WITH IMAGE ( https://tailwindui.com/components/marketing/sections/content-sections#component-be88a98fa8e54342829a636bd0bff3f6 )  */

import React, { useRef } from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Label from 'src/components/Label'
import FluidImage from 'src/utils/FluidImage'
import Button from 'src/components/Button'
import GovoxBubbleOverlay from 'src/images/bubble_inverted.svg';
import Wave from 'src/utils/Wave';
import InView from 'src/utils/InView';

const SplitWithImage = ({ blok }) => {
    const refLeft = useRef()
    const refRight = useRef()
    const isVisibleLeft = InView(refLeft, true)
    const isVisibleRight = InView(refRight, true)
    const animationClassesLeft = `duration-500 opacity-0 translate-y-10 ${isVisibleLeft && 'opacity-100 !translate-y-0'} ${blok.flip && 'lg:delay-300'}`
    const animationClassesRight = `duration-500 opacity-0 translate-y-10 ${isVisibleRight && 'opacity-100 !translate-y-0'} ${!blok.flip && 'lg:delay-300'}`

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                {(blok.curve_position === "top" && blok.blue_background) && 
                    <Wave size="small" className="fill-blue" flip/>
                }
                <div className={`${blok.blue_background ? 'bg-blue text-white' : 'bg-white'} overflow-hidden`}>
                    <div
                        className={`relative flex flex-col items-center max-w-7xl mx-auto py-14 lg:py-28 px-6 xl:gap-20 gap-10 2xl:max-w-screen-2xl
                        ${blok.flip ? "lg:flex-row-reverse" : "lg:flex-row"
                        }`}
                    >
                        <div className={`relative w-full xl:w-2/5 lg:w-1/2 lg:max-w-none max-w-xl ${animationClassesLeft}`} ref={refLeft}>
                            <FluidImage
                            className="object-cover object-center"
                            image={blok.image}
                            />
                            {blok.bubble_shape && 
                                <GovoxBubbleOverlay className={`absolute z-20 top-0 left-0 w-full h-full ${blok.blue_background ? 'fill-blue' : 'fill-white'}`}/>
                            }
                        </div>
                        <div 
                            className={`w-full xl:w-3/5 lg:w-1/2 flex flex-col lg:gap-4 gap-2 items-start ${animationClassesRight}`}
                            ref={refRight}
                        >
                            <Label className="text-teal">{blok.label}</Label>
                            <Heading size="h3">{blok.title}</Heading>
                            <div className={`prose md:text-base text-sm ${blok.blue_background ? 'text-darkblue-400' : ''}`}>
                                <RichText>{blok.description}</RichText>
                            </div>
                            {blok.button_text &&
                                <Button to={blok.button_target.cached_url} target={blok.button_target?.linktype !== 'story' && '_blank'} anchor={blok.button_target?.anchor} className="mt-6">{blok.button_text}</Button>
                            }
                        </div>
                    </div>
                </div>
                {(blok.curve_position === "bottom" && blok.blue_background) && 
                    <Wave size="small" className="fill-blue"/>
                }
            </div>
        </SbEditable>
    )
}

export default SplitWithImage
